// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"APIPurchaseCommissionPage_inputContainer__1cjFg","headerActions":"APIPurchaseCommissionPage_headerActions__2ZyV0"};